"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Accordion.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Accordion = _ref => {
  let {
    children = [],
    defaultOpenIndexArray,
    openIndexArray,
    onChange,
    isMultiple = false,
    title,
    className,
    sectionClassName,
    sectionTitleClassName,
    sectionContentClassName
  } = _ref;
  const [stateOpenIndexArray, setStateOpenIndexArray] = (0, _reactUseControlledState.default)(defaultOpenIndexArray, openIndexArray, onChange);
  const handleSectionClick = index => {
    if (isMultiple || stateOpenIndexArray && stateOpenIndexArray.includes(index)) {
      return setStateOpenIndexArray(Array.from(new Set([...stateOpenIndexArray.filter(value => value !== index), ...[index].filter(value => !stateOpenIndexArray.includes(value))])));
    }
    return setStateOpenIndexArray([index]);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Accordion', className)
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Accordion-Title"
  }, title), _react.Children.map(children, (section, index) => /*#__PURE__*/_react.default.cloneElement(section, {
    index,
    isOpen: stateOpenIndexArray.includes(index),
    key: index,
    onClick: () => handleSectionClick(index),
    className: sectionClassName,
    titleClassName: sectionTitleClassName,
    contentClassName: sectionContentClassName
  })));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map